import React from 'react'

import { connect } from 'react-redux'
import { LogOut } from '../../../Store/Actions/Auth.Action'

// import { Redirect } from 'react-router-dom'

class Logout extends React.Component {
    state = {
        redirectStatus: false
    }
    componentDidMount() {
        this.props.LogOut()
        setTimeout(() => this.setState({ redirectStatus: true }), 0)
    }
    render() {
        const redirectStatus = this.state.redirectStatus
        return (
            <div>
                {redirectStatus ? window.location.href = '/' : <div></div>}
            </div>
        )
    }
}

const mapStateToProps = state => ({
})

export default connect(mapStateToProps, { LogOut })(Logout)
